import { Link } from 'react-router-dom';
import PageHero from '@/components/PageHero';
import TripleSection from '@/components/TripleSection';
import CTABanner from '@/components/CTABanner';
import s from '@/components/home.module.css';

const quotes = [
  { text: 'I prepare your matter, surface the questions only an attorney can answer, and stay with the file 24/7. Your attorney handles judgment. I handle everything else.', attr: 'ELARIA / Role' },
  { text: 'Every citation I produce is verified against primary sources before it leaves the system. Hallucination is a defect, not an acceptable failure mode.', attr: 'ELARIA / Verification' },
  { text: 'I do not advise. I prepare. The distinction matters.', attr: 'ELARIA / Boundary' },
  { text: 'Your matter has 47 open items. Three need attorney decisions this week. The other 44 I can complete tonight.', attr: 'ELARIA / Throughput' },
];

export default function Elaria() {
  return (
    <>
      <PageHero
        eyebrow="The agent"
        title="ELARIA — the operations layer."
        sub="The AI agent that runs inside AVOWAL. Patent-pending architecture, built from the ground up for legal work: citation verification, hallucination detection, audit-trail evidence chains, and a bridge into court e-filing."
      />

      <TripleSection
        id="boundary"
        label="What it is — and is not"
        title="ELARIA executes. Your attorney decides."
        cards={[
          { num: '/ DOES', title: 'Operations', body: 'Intake, document drafting, citation verification, deadline tracking, evidence organization, communications, filing prep, audit trails. The mechanical layer of practice.' },
          { num: '/ DOES NOT', title: 'Legal advice', body: 'ELARIA does not advise on strategy, predict outcomes, or substitute for an attorney. Every judgment call is escalated to the attorney. Every output is reviewed before filing.' },
          { num: '/ NEVER', title: 'Fabricates', body: 'Every citation is verified against primary sources before it leaves the system. Every fact is traceable to its document. Hallucination is treated as a defect, not an acceptable failure mode.' },
        ]}
      />

      <section>
        <div className="container">
          <span className={s.sectionLabel}>In its own words</span>
          <h2 className={s.sectionTitle}>How ELARIA describes the job.</h2>
          <div className={s.quoteGrid}>
            {quotes.map((q) => (
              <blockquote key={q.attr} className={s.quote}>
                <span className={s.quoteText}>&ldquo;{q.text}&rdquo;</span>
                <span className={s.quoteAttr}>{q.attr}</span>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      <section id="agentic">
        <div className="container">
          <span className={s.sectionLabel}>Under the hood</span>
          <h2 className={s.sectionTitle}>Agentic, not conversational.</h2>
          <p className={s.sectionLead}>
            ELARIA is not a chatbot with a legal vocabulary. It is an agent: it holds a goal, plans
            the steps, executes them, and checks its own work — then queues what only an attorney can
            decide. The same engine is also available on hardware the firm owns, offline-capable, as a
            founding-firm engagement.
          </p>
          <Link to="/ai" className={s.moreLink}>
            Learn how agentic AI works &rarr;
          </Link>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
